import Axios from "axios";
import {
    SET_PUR_PO_APPROVAL_REPORT,
    UNSET_PUR_PO_APPROVAL_REPORT,
} from "@/store/mutation-types";
import { getPurPOApprovalReport } from "@/store/api";

const state = {
    getPurPOApprovalReport: [],
};

const getters = {
    getPurPOApprovalReport(state) {
        return state.getPurPOApprovalReport;
    },
};

const mutations = {
    [SET_PUR_PO_APPROVAL_REPORT](state, data) {
        state.getPurPOApprovalReport = data;
    },
    [UNSET_PUR_PO_APPROVAL_REPORT](state) {
        state.getPurPOApprovalReport = [];
    },
};

const actions = {
    getPurPOApprovalReport({ commit }, params) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getPurPOApprovalReport, { params })
                .then((response) => {
                    commit(SET_PUR_PO_APPROVAL_REPORT, response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_PUR_PO_APPROVAL_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};


